export const getLoadErrorFromChildren = (children) =>
   Object.values(children).reduce(
      (acc, { loadError }) => acc || loadError,
      false
   );
